<template>
  <div>
    <div v-if="mainStore.module.base == 'MAXIRACE26'">
      <MAXIRACE26RetraitDossardHook :inscription="item"></MAXIRACE26RetraitDossardHook>
    </div>
    <div class="d-flex flex-wrap gap">
      <InformationCoureur :item="item"></InformationCoureur>
      <InfosFinanceInscription :inscription="item"></InfosFinanceInscription>
      <InfosEtatInscription :item="item"></InfosEtatInscription>
      <InfosCommande :item="item"></InfosCommande>
      <InfosHistoryInscription :item="item"></InfosHistoryInscription>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import InformationCoureur from "@/components/Administration/Edit_Inscriptions/Resume/InformationCoureur.vue";
import InfosFinanceInscription from "@/components/Administration/Edit_Inscriptions/InfosFinanceInscription.vue";
import InfosEtatInscription from "@/components/Administration/Edit_Inscriptions/Resume/InfosEtatInscription.vue";
import InfosCommande from "@/components/Administration/Edit_Inscriptions/Resume/InfosCommande.vue";
import InfosHistoryInscription from "@/components/Administration/Edit_Inscriptions/Resume/InfosHistoryInscription.vue";
import MAXIRACE26RetraitDossardHook from "@/components/Hooks/MAXIRACE26_retrait_dossard.vue";
export default {
  components: {
    InformationCoureur,
    InfosFinanceInscription,
    InfosEtatInscription,
    InfosCommande,
    InfosHistoryInscription,
    MAXIRACE26RetraitDossardHook,
  },
  props: ["item"],
  computed: {
    ...mapStores(useMainStore),
    displayHistory() {
      const isFromBourseDossards = this.item.from_bourse_dossards == '1';
      const isFromTransfert = this.item.from_transfert == '1';
      const isSold = this.item.bourse_dossards_status == 'PAID';
      const isTransfered = this.item.transfere == '1';
      return isFromBourseDossards || isFromTransfert || isSold || isTransfered;
    }
  }
};
</script>

<style lang="scss" scoped></style>